import { get, generateUUID } from './index';

const hashCode = (input = '') => {
    let hash = 0;
    if (input.length === 0) {
        return hash;
    }
    for (let i = 0; i < input.length; i++) {
        const char = input.charCodeAt(i);
        /* eslint-disable no-bitwise */
        hash = ((hash << 5) - hash) + char;
        hash &= hash; // Convert to 32bit integer
        /* eslint-enable no-bitwise */
    }
    return hash;
};

export const hashCodeOfWithFallback = (on, props, fallback = generateUUID) => {
    let [fb, properties] = [fallback, props];
    if (typeof props === 'function') {
        [fb, properties] = [props, fallback];
    }

    return hashCode(get(on, properties)) || fb();
};

export default hashCode;
